export { default as LocalAuthorityDetail } from "./local-authority-detail"
export { default as LocalAuthorityList }   from "./local-authority-list"
export { default as LocalAuthorityDashbord }   from "./local-authority-dashbord"


// WEBPACK FOOTER //
// ./src/component/local-authority/index.js